// extracted by mini-css-extract-plugin
module.exports = {"right":"RightDisplay_right__2SllD","bottomRight":"RightDisplay_bottomRight__1tfwl"};